import { Instance } from 'mobx-state-tree';
import { InsightsDriverBreakdownOvertimeDtoModelBase } from './InsightsDriverBreakdownOvertimeDtoModel.base';

/* The TypeScript type of an instance of InsightsDriverBreakdownOvertimeDtoModel */
export interface InsightsDriverBreakdownOvertimeDtoModelType extends Instance<typeof InsightsDriverBreakdownOvertimeDtoModel.Type> {}

/* A graphql query fragment builders for InsightsDriverBreakdownOvertimeDtoModel */
export {
  selectFromInsightsDriverBreakdownOvertimeDto,
  insightsDriverBreakdownOvertimeDtoModelPrimitives,
  InsightsDriverBreakdownOvertimeDtoModelSelector,
} from './InsightsDriverBreakdownOvertimeDtoModel.base';

/**
 * InsightsDriverBreakdownOvertimeDtoModel
 */
export const InsightsDriverBreakdownOvertimeDtoModel = InsightsDriverBreakdownOvertimeDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
